"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintProvider = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var hotkeysProvider_1 = require("./hotkeys/hotkeysProvider");
var overlaysProvider_1 = require("./overlays/overlaysProvider");
var portalProvider_1 = require("./portal/portalProvider");
/**
 * Composite Blueprint context provider which enables & manages various global behaviors of Blueprint applications.
 *
 * @see https://blueprintjs.com/docs/#core/context/blueprint-provider
 */
var BlueprintProvider = function (_a) {
    var children = _a.children, hotkeysProviderValue = _a.hotkeysProviderValue, props = tslib_1.__rest(_a, ["children", "hotkeysProviderValue"]);
    return (React.createElement(portalProvider_1.PortalProvider, tslib_1.__assign({}, props),
        React.createElement(overlaysProvider_1.OverlaysProvider, null,
            React.createElement(hotkeysProvider_1.HotkeysProvider, tslib_1.__assign({ value: hotkeysProviderValue }, props), children))));
};
exports.BlueprintProvider = BlueprintProvider;
//# sourceMappingURL=blueprintProvider.js.map